import type { FC, PropsWithChildren } from 'react'

import { Container } from '@skytech/ui/Container'

import { DrillDownRoutes } from '@/modules/admin/drilldown/DrillDownRoutes'

import { DrillDownContextProvider } from './context/index.context'

import './index.styles.scss'

export const DrillDown: FC = () => (
  <Container className="drill-down">
    <DrillDownContextProvider>
      <DrillDownRoutes />
    </DrillDownContextProvider>
  </Container>
)

export const DrillDownContainer: FC<PropsWithChildren> = ({ children }) => (
  <Container className="drill-down">
    <DrillDownContextProvider>{children}</DrillDownContextProvider>
  </Container>
)
